exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".verify-link[data-v-3941a3c7]{text-decoration:underline;color:#009cde;display:block;margin-top:.5rem}", ""]);

// exports
